// extracted by mini-css-extract-plugin
export default {"container_section":"CartSummary_container_section__Btbgc","product_wrapper":"CartSummary_product_wrapper__hD82w"};